import type { TourChapter } from "../types";

export const OFFLINE_CHAPTER: TourChapter = {
  id: "offline",
  title: "Offline",
  steps: [
    {
      id: "why", target: null, title: "Reviewing with no signal",
      body:
        "Download a flight from the viewer's Export menu and it plays here with no connection at " +
        "all: video, map, footprint, overlays and everything saved so far. Any edits you make " +
        "offline upload when you're back.",
    },
    {
      id: "storage", target: "offline.summary", title: "Storage",
      body:
        "How many flights are on this device and the space they're taking. Grant persistent " +
        "storage so the browser won't quietly clear them out when disk gets tight; on Safari, " +
        "add the app to your Home Screen instead.",
    },
    {
      id: "table", target: "offline.table", title: "Your downloads",
      body:
        "One row per flight: the quality you picked, its size, when it came down, and its health " +
        "once it's been verified.",
    },
    {
      id: "verify", target: "offline.verify", title: "Verify all",
      body:
        "Checks every download is complete. 🟢 is good; 🟡 or 🔴 means something's been cleared or " +
        "is out of date, so refresh it while you've got signal.",
    },
    {
      id: "actions", target: "offline.actions", title: "Refresh and Remove",
      body:
        "Refresh only re-downloads if the flight changed on the server. Remove frees up the " +
        "space.",
    },
    {
      id: "done", target: null, title: "You're all set",
      body: "That's the lot. Bring the tour back any time with ? Tour in the header.",
    },
  ],
};
